module.exports = __webpack_public_path__ + "static/ssut-a829e5c6c40e0ba401b3425153f540a9.jpg";